import { hideLoader } from '/src/components/loader/loader';
import counterLogic from './views/metrics/counter';

document.addEventListener('DOMContentLoaded', onDOMContentLoaded);

function onDOMContentLoaded() {
  hideLoader();
  counterLogic();
}
